import React from 'react';
import AnimateBlock from '../../components/AnimateBlock/AnimateBlock';
import BlockHeader from '../../components/BlockHeader/BlockHeader';
import YFMWrapper from '../../components/YFMWrapper/YFMWrapper';
import { block } from '../../utils';
import './Simple.css';
const b = block('simple-block');
export const SimpleBlock = (props) => {
    const { title, description, animated = true, children } = props;
    const blockHeader = title && React.createElement(BlockHeader, { title: title });
    return (React.createElement(AnimateBlock, { className: b(), animate: animated },
        React.createElement("div", null,
            blockHeader,
            React.createElement("div", { className: b('description') },
                React.createElement(YFMWrapper, { content: description, modifiers: { constructor: true } })),
            React.createElement("div", { className: b('animate-block') }, children))));
};
export default SimpleBlock;
